// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebt-schedule-switch{font-weight:600}`, "",{"version":3,"sources":["webpack://./src/components/RightPanel/SchedulingConfiguration/ToggleButton/Style.scss"],"names":[],"mappings":"AAEA,qBACE,eAAA","sourcesContent":["@use \"~@emisgroup/design-tokens/build/scss/variables\" as tokens;\n\n.ebt-schedule-switch {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
